let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2yQO1")).then(() => parcelRequire('d67Vm'));